<template>
  <section class="content-block">
    <div class="max-w-7xl mx-auto px-4 py-8">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="prose max-w-none">
          <h1 class="text-red-600 text-3xl font-bold mb-6">
            {{ content.title }}
          </h1>
          <div
            v-html="content.content"
            class="text-font-primary space-y-4"
          ></div>
        </div>
        <div v-if="image" class="flex justify-center items-start">
          <NuxtImg
            provider="strapi"
            :src="image.url"
            :alt="image.alternativeText || 'About Us'"
            width="600"
            height="400"
            class="rounded-lg"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: {
    title: string;
    content: string;
    image?: any;
  };
}>();

const { getImageData } = useStrapiUtils();
const image = computed(() =>
  props.content.image ? getImageData(props.content.image) : null
);
</script>

<style scoped>
.content-block {
  @apply bg-white;
}

:deep(a) {
  @apply text-red-600 hover:text-red-700 underline;
}

:deep(p) {
  @apply mb-4;
}
</style>
